export default __webpack_public_path__ + "static/media/oscer-pres-perianal-pain.b5fa67f1.svg";